import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../../assets/Images/Videos/Video-Residential.mp4'
import _imports_1 from '../../assets/Images/Videos/Video-Investment.mp4'
import _imports_2 from '../../assets/Images/logo02.png'


const _hoisted_1 = { class: "home-realtors" }
const _hoisted_2 = {
  class: "modal fade",
  id: "modalProducts",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-xl" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("video", {
  src: _imports_0,
  class: "tw-w-full",
  controls: "",
  autoplay: ""
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("video", {
  src: _imports_1,
  class: "tw-w-full",
  controls: "",
  autoplay: ""
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "container-fixed" }
const _hoisted_14 = { class: "home-realtors__navbar" }
const _hoisted_15 = { class: "navbar navbar-expand-lg d-flex justify-content-between tw-bg-[#fff]" }
const _hoisted_16 = {
  class: "collapse navbar-collapse d-flex justify-content-between",
  id: "navbarTogglerDemo01"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "/"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1)
const _hoisted_18 = { class: "form-inline my-2 my-lg-0" }
const _hoisted_19 = { class: "navbar-nav mr-auto mt-2 mt-lg-0 d-flex align-items-center" }
const _hoisted_20 = { class: "nav-item active tw-pr-[40px]" }
const _hoisted_21 = { class: "nav-item active tw-pr-[26px] tw-pl-[2px]" }
const _hoisted_22 = { class: "nav-item active pr-4 tw-relative" }
const _hoisted_23 = { class: "dropdown tw-block tw-relative" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("a", {
  class: "tw-bg-white tw-text-[#606060] tw-flex tw-justify-between tw-w-[150px] tw-items-center",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" PRODUCTS "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down tw-pb-0.5" })
], -1)
const _hoisted_25 = { class: "dropdown-menu" }
const _hoisted_26 = { class: "nav-item tw-pr-[45px] tw-pl-[30px]" }
const _hoisted_27 = { class: "nav-item dropdown" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "navbarDropdownMenuLink",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " SIGN UP ", -1)
const _hoisted_29 = {
  class: "dropdown-menu",
  "aria-labelledby": "navbarDropdownMenuLink"
}
const _hoisted_30 = ["href"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "tw-mt-[100px]" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-justify-around tw-gap-[50px]" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[40px] tw-text-[#00a0da]" }, "TITLE COMPANY"),
      /*#__PURE__*/_createElementVNode("video", {
        class: "tw-mt-[20px]",
        src: "https://www.realtortools.org/media/VideoTitleCompany.mp4",
        width: "900",
        height: "250",
        poster: "https://www.realtortools.org/media/vista-previa.png",
        controls: ""
      })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_routerLink = _resolveComponent("routerLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          (_ctx.productSelected)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_ctx.productSelected.toString() == '1')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                  : _createCommentVNode("", true),
                (_ctx.productSelected.toString() == '2')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("nav", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("form", _hoisted_18, [
              _createElementVNode("ul", _hoisted_19, [
                _createElementVNode("li", _hoisted_20, [
                  _createVNode(_component_routerLink, { to: "/" }, {
                    default: _withCtx(() => [
                      _createTextVNode("HOME")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_21, [
                  _createVNode(_component_routerLink, { to: "/target" }, {
                    default: _withCtx(() => [
                      _createTextVNode("TARGET")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_22, [
                  _createElementVNode("a", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("ul", _hoisted_25, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal('modalProducts', '1')))
                        }, "RESIDENTIAL")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('modalProducts', '2')))
                        }, "INVESTMENT")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("li", _hoisted_26, [
                  _createVNode(_component_routerLink, { to: "/loginusers" }, {
                    default: _withCtx(() => [
                      _createTextVNode("LOG IN ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("ul", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listRoles, (role) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (role.name != 'ADMIN')
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "dropdown-item",
                              id: "option",
                              href: '/register?type=' + role.idRole
                            }, _toDisplayString(role.name), 9, _hoisted_30))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 256))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_31
  ]))
}